import {
  FETCH_FE_DATA_REQUEST,
  FETCH_FE_DATA_SUCCESS,
  FETCH_FE_DATA_ERROR
} from './actions';
import { camelizeKeys } from '../../util/general';

export const INITIAL_STATE = Object.freeze({
  user: {},
  account: {},
  accountFeatures: {},
  permissions: {},
  roles: [],
  abilities: {},
  isFetching: false,
  isLoaded: false,
  error: null,
});

export default function feDataReducer(
  state = INITIAL_STATE,
  action
) {
  switch (action.type) {
    case FETCH_FE_DATA_REQUEST:
      return { ...state, error: null, isFetching: true };
    case FETCH_FE_DATA_SUCCESS:
      return {
        ...state,
        user: camelizeKeys(action.payload.current_user),
        account: camelizeKeys(action.payload.current_account),
        accountFeatures: camelizeKeys(action.payload.account_features),
        permissions: camelizeKeys(action.payload.permissions),
        abilities: action.payload.account_abilities,
        roles: action.payload.roles,
        isFetching: false,
        isLoaded: true,
      };
    case FETCH_FE_DATA_ERROR:
      return { ...state, error: action.payload, isFetching: false };
    default:
      return state;
  }
}
